var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-block state-loading",attrs:{"role":"status"}},[_c('span',{staticClass:"loading-line"}),_c('span',[_vm._v(_vm._s(_vm.label || _vm.$store.getters.t('loading')))])])}
var staticRenderFns = []

export { render, staticRenderFns }